import logo from "./logo.svg";
import React, { useEffect, useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import "./App.css";
import "./tailwindcss.css";
import { Helmet } from "react-helmet";
import RenderRoutes from "./routes";
import { getVisitorServiceUrl } from "./services/api-constants";
import { currentDomain } from "./utils/general-config";
import { readCookie, sendRaygunError, useGTM } from "./utils/helpers";
import Favicon from "react-favicon";
import $ from "jquery";
import StickyChat from "./utils/stickyChat";
import { DomainName } from "./utils/constants";
import LegalSimpliFavIcon from "./lsfavico.ico";
import PdfSimpliFavIcon from "./psfavico.ico";
import ResumeBuildFavIcon from "./ResumeBuild-favicon.png";
import SignSimpliFavIcon from "./ssfavico.ico";
import worksimpliFavicon from "./wsfavico.ico";
import { useTranslation } from "react-i18next";

function AppContent() {
  const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;
  const location = useLocation(); // Now works as it is inside BrowserRouter
  let referrer = document.referrer || ""; // Initial referrer
  const [faviconUrl, setFaviconUrl] = useState("");
  const url = getVisitorServiceUrl("");
  window.$ = $;
  window.jQuery = $;
  let domain = currentDomain();
  useGTM();
  const { i18n } = useTranslation();

  //TODO: will remove it after our analysis for vs_portalsrc cookie null value
  // useEffect(() => {
  //   const prtlSrc = readCookie("vs_prtlSrc");

  //   if (prtlSrc === null) {
  //     sendRaygunError("vs_prtlSrc cookie is null", {
  //       route: window.location.pathname,
  //       url: window.location.href,
  //       userAgent: navigator.userAgent,
  //     });
  //   }
  // }, []);

  useEffect(() => {
    document.documentElement.setAttribute("lang", i18n.language);
    if (i18n.language === "ar") {
      document.documentElement.setAttribute("dir", "rtl");
    } else {
      document.documentElement.setAttribute("dir", "ltr");
    }
  }, [i18n.language]);
  useEffect(() => {
    const lowerDomain = domain.toLowerCase();
    const isLocalhost = window.location.href.includes("localhost");
    const faviconMap = {
      legalsimpli: LegalSimpliFavIcon,
      signsimpli: SignSimpliFavIcon,
      resumebuild: ResumeBuildFavIcon,
      pdfsimpli: PdfSimpliFavIcon,
    };

    let favicon = `${process.env.PUBLIC_URL}/static/favicon.ico`;

    if (lowerDomain === "worksimpli" || isLocalhost) {
      favicon = worksimpliFavicon;
    } else if (faviconMap[lowerDomain]) {
      favicon = faviconMap[lowerDomain];
    }

    setFaviconUrl(favicon);

    // PDFSIMPLI-specific logic
    if (domain === "pdfsimpli") {
      const rsknABTest = readCookie("rsknABTest");
      if (!rsknABTest) {
        document.body.classList.add("brands-font");
      }
    } else {
      document.body.classList.remove("brands-font");
    }

    // Cleanup
    return () => {
      document.body.classList.remove("brands-font");
    };
  }, []);
  useEffect(() => {
    if (window.addDataTrackAttribute) {
      window.addDataTrackAttribute();
    }

    // Log a page view whenever the route changes
    if (window.logPageView) {
      window.logPageView({ referrer }); // Pass the tracked referrer
    }
    referrer = window.location.href;
    // Update the referrer for the next navigation
    // Attach global listeners for user interaction events
    if (window.attachListeners) {
      window.attachListeners();
    }
    if (window.startQueueProcessor) {
      window.startQueueProcessor();
    }
  }, [location.pathname]);

  const loadManifest = () => {
    let manifestUrl;
    if (currentDomain() === DomainName.RESUMEBUILD) {
      manifestUrl = `${process.env.PUBLIC_URL}/static/manifests/manifest-rb.json`;
    } else if (currentDomain() === DomainName.PDFSIMPLI) {
      manifestUrl = `${process.env.PUBLIC_URL}/static/manifests/manifest-pdf.json`;
    } else if (currentDomain() === DomainName.SIGNSIMPLI) {
      manifestUrl = `${process.env.PUBLIC_URL}/static/manifests/manifest-ss.json`;
    } else if (currentDomain() === DomainName.LEGALSIMPLI) {
      manifestUrl = `${process.env.PUBLIC_URL}/static/manifests/manifest-ls.json`;
    } else {
      manifestUrl = `${process.env.PUBLIC_URL}/static/manifests/manifest-pdf.json`;
    }
    const link = document.createElement("link");
    link.rel = "manifest";
    link.href = manifestUrl;
    document.head.appendChild(link);
  };
  useEffect(() => {
    loadManifest();
  }, []);

  return (
    <>
      <Favicon url={faviconUrl} />
      <StickyChat />
      <Helmet>
        <script src={url} type="text/javascript" />
      </Helmet>
      <RenderRoutes />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
